export default "__VITE_ASSET__RSFvtyKR__"